export const FETCH_AGGREGATE_DOMAINS_REQUEST = 'FETCH_AGGREGATE_DOMAINS_REQUEST';
export const FETCH_AGGREGATE_DOMAINS_SUCCESS = 'FETCH_AGGREGATE_DOMAINS_SUCCESS';
export const FETCH_AGGREGATE_DOMAINS_FAILURE = 'FETCH_AGGREGATE_DOMAINS_FAILURE';
